import Contact from './components/Contact.vue';
import PizzaDoughCalculator from './components/PizzaDoughCalculator.vue';
/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
// window.Blazy = require('blazy');

// var bLazy = new Blazy({
// 		offset:150,
// 		container: '.slidebarsContainer',
// 		//loadInvisible: true
// 	});
import lozad from 'lozad';
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

//Vue.component('example', require('./components/Example.vue'));
//Vue.component('chartist', require('./components/Chartist.vue'));
Vue.component('contact', Contact);
Vue.component('pizza-dough-calculator', PizzaDoughCalculator);



const app = new Vue({
    el: '#app',
    data() {
        return {
            test:'japp'
        }
    },
});
const dough = new Vue({
    el: '#DoughCalculator'
});

window.$ = window.jQuery = require('jquery');

require('./waitforimages.js');
require('./cases_animation.js');
require('./cases_bkg_images.js');

require('./thidrandi_functions.js');
require('./thidrandi.js');
require('./thidrandi_headersliders.js');
require('./thidrandi_projectslider.js');
require('./slidebars.js');
require('./gdpr/cookieconsent.js');
require('./gdpr/gdpr.js');


$(window).on("load", function (e) {
	
	
		if($('.hideUntilLoaded').length) {
			$('.hideUntilLoaded').addClass('show');
		}
		

	// console.log($('.slidebarsContainer').height());
	// console.log($(window).height());
	// console.log($(document).height());

})




